import BasicImage from '@home/components/BasicImage';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import { dynamicString } from '@home/utils/dynamicString';
import ChannelLabel from '@op/components/ChannelLabel';
import React from 'react';
import DefaultImg from '@/pages/opinion/assets/imgs/influencer-user-avatar.png';

export const getCampaignRender = (row: any) => {
  const {
    children,
    campaign_name,
    channel_name,
    channel_picture,
    platform = '',
    // fix_language,
  } = row;
  if (children || campaign_name === 'TOTAL') {
    return <div className="dbh-kol-table-compaign-text">{campaign_name}</div>;
  }

  return (
    <div className="dbh-kol-table-compaign-content">
      <div className="dbh-kol-table-compaign-left">
        <BasicImage src={channel_picture || ''} errorSrc={DefaultImg} />
      </div>
      <div className="dbh-kol-table-compaign-right">
        <div className="dbh-kol-table-compaign-right-name">{channel_name}</div>
        <div className="dbh-kol-table-compaign-right-country">
          <div className="dbh-kol-table-compaign-right-country-icon">
            <ChannelLabel channel_name={platform?.toLowerCase()} showText={false} />
          </div>
          {/* <div className="dbh-kol-table-compaign-right-country-line"></div>
          <div className="dbh-kol-table-compaign-right-country-name">
            {fix_language}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export const getProgressRender = (row: any, item: any) => {
  const {
    metricKey = '',
    percentKey = '',
    valueFormat,
    percentFormat = 'percent2Decimal',
  } = item || {};
  const { isChildren } = row || {};
  // 动态获取值
  const rowValue = dynamicString(metricKey, row);
  const rowPercent = dynamicString(percentKey, row);
  const value = dataFormat({ value: rowValue, formatRule: valueFormat });
  const percnetValue = dataFormat({
    value: rowPercent,
    formatRule: percentFormat,
  });
  // 判断是否有百分比副值，还是本身就是百分比
  let progressWidth = rowValue ? value : 0;
  if (percentKey) {
    progressWidth = rowPercent ? percnetValue : 0;
  }
  return (
    <div className="dbh-kol-table-progress-render">
      <div className="dbh-kol-table-progress-render-text">
        <div className="dbh-kol-table-progress-render-text-value">{value}</div>
        {percentKey && (
          <div className="dbh-kol-table-progress-render-text-percent">
            ({percnetValue})
          </div>
        )}
      </div>
      <div className="dbh-kol-table-progress">
        <div
          className="dbh-kol-table-progress-bg"
          style={{
            width: progressWidth,
            background: isChildren ? '#6E7794' : '#5086f3',
          }}
        ></div>
      </div>
    </div>
  );
};

export default {
  getCampaignRender,
  getProgressRender,
};
